import { ref, Ref } from "vue";

/**
 * Hook pour la gestion d'un booléen réactif
 * @param bool Valeur initiale
 * @returns refBoolean (Ref<boolean>), doChangeBoolean (setter), doSwitchBoolean (toggle)
 */
function useBoolean(bool: boolean = false) {
  const refBoolean: Ref<boolean> = ref(bool);

  const doChangeBoolean = (newBoolean: boolean) => {
    refBoolean.value = newBoolean;
  };

  const doSwitchBoolean = () => {
    refBoolean.value = !refBoolean.value;
  };

  return {
    refBoolean,
    doChangeBoolean,
    doSwitchBoolean,
  };
}

export default useBoolean;
